import React, { Component } from 'react';
import { Row, Col, Icon } from 'antd';
import { Link } from "react-router-dom";
import Info from '../common/info';
import Clock from '../common/clocks';

export default class Page extends Component {
    render() {
        return (
            <div className="myFooter">
                {/* <div className={"footerTopVintage"} style={{ bottom: 'calc( 100% - 32px)' }}>
                    <img src="../../clientAssets/footerImg.png" alt="" />
                </div> */}
                <div className={"footerWrapper"}>
                    <div className={"footerGoldBorder"}></div>
                    <div className="container">
                        <div className="mainFooter">
                            <div className="mainFooterInner">
                                <Row className={"footerRow"} type={'flex'} justify={"center"} align={'top'}>
                                    <Col xs={22} sm={22} md={8} lg={8} xl={8}>
                                        <div className="footerLeft">
                                            <Row className="footerLinks">
                                                <Col span={8}>
                                                    <div className="footerLinkColumn">
                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>خانه</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/world-clock"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>ساعت‌جهانی</p>
                                                            </Link>
                                                        </div>



                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/in-development"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>ماشین‌حساب</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/termsAndConditions"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>قوانین‌و‌مقررات</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/sign-up"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>ثبت‌نام</p>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </Col>


                                                <Col span={8}>
                                                    <div className="footerLinkColumn">
                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/price-list/exchange-rate"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>نرخ ارز</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/price-list/transfer-rate"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>نرخ حواله</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/price-list/coin-rate"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>نرخ سکه</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/price-list/bank-rate"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>نرخ بانکی</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/careers"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>فرصت‌های شغلی</p>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </Col>


                                                <Col span={8}>
                                                    <div className="footerLinkColumn">
                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/articles"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>مقالات</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/economicNews"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>اخبار</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/forms"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>فرم‌ها</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/FAQ"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>سوالات‌متداول</p>
                                                            </Link>
                                                        </div>

                                                        <div className={"footerLinkItem"}>
                                                            <Link to={"/certificates"}>
                                                                <div>
                                                                    <Icon type="facebook" />
                                                                </div>
                                                                <p>مجوز‌ها</p>
                                                            </Link>
                                                        </div>

                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col xs={22} sm={22} md={8} lg={8} xl={8}>
                                        <div className="FooterCenter">
                                            <div className="footerSocials">
                                                <div className="footerSocial">
                                                    <a href="#">
                                                        <Icon type="facebook" />
                                                    </a>
                                                </div>

                                                <div className="footerSocial">
                                                    <a href="https://www.instagram.com/bayati.exchange/" target={"_blank"} >
                                                        <Icon type="instagram" />
                                                    </a>
                                                </div>

                                                <div className="footerSocial">
                                                    <a href="#">
                                                        <Icon type="linkedin" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="footerClock">
                                                <Clock countryName={"iran"} />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={22} sm={22} md={8} lg={8} xl={8}>
                                        <div className="footerRight">
                                            <Row className="footerPhones">
                                                <Col span={12}>
                                                    <div className="footerContactItem">
                                                        <div>
                                                            <Icon type="phone" />
                                                        </div>
                                                        <p>{Info.PHONE}</p>
                                                    </div>
                                                </Col>

                                                <Col span={12}>
                                                    <div className="footerContactItem">
                                                        <div>
                                                            <Icon type="phone" />
                                                        </div>
                                                        <p>{Info.PHONE}</p>
                                                    </div>
                                                </Col>




                                                <Col span={12}>
                                                    <div className="footerContactItem">
                                                        <div>
                                                            <Icon type="printer" />
                                                        </div>
                                                        <p>{Info.FAX}</p>
                                                    </div>
                                                </Col>

                                                <Col span={12}>
                                                    <div className="footerContactItem">
                                                        <div>
                                                            <Icon type="mobile" />
                                                        </div>
                                                        <p>{Info.MOBILE}</p>
                                                    </div>
                                                </Col>



                                                <Col span={12}>
                                                    <div className="footerContactItem">
                                                        <div>
                                                            <Icon type="mail" />
                                                        </div>
                                                        <p>{Info.EMAIL}</p>
                                                    </div>
                                                </Col>




                                                <Col span={24}>
                                                    <div className="footerContactItem">
                                                        <div>
                                                            <Icon type="environment" />
                                                        </div>
                                                        <p className={"footerAddress"}>{Info.ADDRESS}</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="myCo">
                                <div className="myCoInnerOne">
                                    <div className="myCoInner">
                                        <div className="footerCopyRight">
                                            <span>© {(new Date()).getFullYear()} تمامی حقوق برای </span>
                                            <a href="#">شرکت تضامنی غالب بیاتی و شرکإ</a>
                                            <span> محفوظ می‌باشد</span>
                                        </div>
                                        <div className="madeWithLove">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}